import { Check, Crown, Info } from "lucide-react"
import type { ReactNode } from "react"

/** Gruener Haken der Feature-Listen. */
export function Tick({ className = "" }: { className?: string }) {
  return <Check className={`h-[18px] w-[18px] shrink-0 text-success ${className}`} strokeWidth={2.4} />
}

/** Ersparnis-Badge. Textfarbe bewusst dunkler als die Flaechenfarbe (Kontrast). */
export function SaveBadge({ amount }: { amount: string }) {
  return (
    <span className="inline-flex items-center whitespace-nowrap rounded-pick bg-success-light px-2.5 py-0.5 text-xs font-medium text-success-text">
      Sie sparen {amount}
    </span>
  )
}

/** Premium-Badge. Neutral, nicht blau: Blau ist im UI fuer Interaktion reserviert. */
export function PremiumBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-pick bg-badge px-3 py-1 text-xs font-medium text-brand">
      <Crown className="h-3 w-3" aria-hidden />
      Premium
    </span>
  )
}

/** Info-Icon mit Tooltip (title reicht hier - reine Zusatzinfo). */
export function InfoHint({ text }: { text: string }) {
  return (
    <span title={text} className="inline-flex cursor-help text-brand-muted" aria-label={text}>
      <Info className="h-4 w-4" />
    </span>
  )
}

/** Inhaltsbreite + Seitenraender, einheitlich fuer alle Baender. */
export function Wrap({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`mx-auto w-full max-w-content px-5 md:px-8 ${className}`}>{children}</div>
}

/** Rote Sektions-Ueberschrift mit Beschreibungstext. */
export function BlockHeading({ title, children }: { title: ReactNode; children?: ReactNode }) {
  return (
    <div className="mb-6 md:mb-10">
      <h2 className="text-xl font-medium text-brand-accent md:text-3xl">{title}</h2>
      {children && <p className="mt-2 max-w-[920px] text-xs text-brand-muted md:mt-3 md:text-base">{children}</p>}
    </div>
  )
}

/** Kleingedrucktes unter einem Preisblock. */
export function FinePrint({ children }: { children: ReactNode }) {
  return <p className="mt-5 text-[12px] leading-[18px] text-brand-muted md:text-xs">{children}</p>
}
